// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KomentarModal_modalOverlay__DfBhc {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000000d6;
  z-index: 100;
  justify-content: center;
}
.KomentarModal_exitBtn__EgV1Q {
  position: absolute;
  top: 5%;
  right: 3%;
  cursor: pointer;
}
.KomentarModal_infoModal__lCz7l {
  flex-direction: column;
  justify-content: center;
  width: 85%;
  padding: 24px 0px 24px 0px;
}
.KomentarModal_infoModal__lCz7l,
.KomentarModal_modalWrapper__gQez2,
.KomentarModal_btnRow__aHLF2,
.KomentarModal_modalOverlay__DfBhc {
  display: flex;
  align-items: center;
}
.KomentarModal_btnRow__aHLF2 {
  justify-content: flex-end;
  gap: 24px;
  width: 90%;
  margin-top: 36px;
  margin-bottom: 32px;
}
.KomentarModal_modalWrapper__gQez2 {
  justify-content: flex-start;
  flex-direction: column;
  width: 70%;
  max-height: 95vh;
  border-radius: 16px;
  border: 1px solid #d1d9e2;
  box-shadow: 0px 1px 2px 0px #1018280d;
  background-color: #ffffff;
}
.KomentarModal_title__iXS7x,
.KomentarModal_subtitle__FpAPT {
  font-family: Inter;
  font-size: 28px;
  font-weight: 600;
  line-height: 34px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #4d4d4d;
}
.KomentarModal_subtitle__FpAPT {
  margin-top: -16px;
}
.KomentarModal_inputWrapper__sP5sn {
  gap: 16px;
  margin-top: 24px;
}
.KomentarModal_inputWrapper__sP5sn,
.KomentarModal_inputColumn__4Ja9e {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  justify-content: center;
}
.KomentarModal_modalInput__BxiZa,
.KomentarModal_inputColumn__4Ja9e,
.KomentarModal_inputWrapper__sP5sn {
  width: 100%;
}
.KomentarModal_modalInput__BxiZa {
  height: 32px;
  text-align: left;
  color: #5f6d7e;
  font-family: Inter;
  font-size: 16px;
  letter-spacing: -0.001em;
}
.KomentarModal_modalInput__BxiZa,
.KomentarModal_textarea__P9EMr {
  padding: 8px;
  font-weight: 500;
  box-shadow: 4px 4px 64px 0px #5f6d7e1a;
  border: 1px solid #d8dbdf;
  border-radius: 8px;
}
.KomentarModal_textarea__P9EMr {
  width: 102%;
  height: 130px;
  background: #ffffff;
  background-origin: border-box;
  background-clip: content-box, border-box;
  color: #828d9a;
  resize: none;
  box-sizing: border-box;
}
.KomentarModal_label__OZ2\\+A {
  text-align: left;
  color: #5f6d7e;
}
.KomentarModal_cancelBtn__lHTWw,
.KomentarModal_successBtn__39HIZ {
  width: 27%;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  height: 52px;
}
.KomentarModal_cancelBtn__lHTWw,
.KomentarModal_successBtn__39HIZ,
.KomentarModal_label__OZ2\\+A,
.KomentarModal_textarea__P9EMr {
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.016px;
}
.KomentarModal_successBtn__39HIZ {
  background: #cb9c2d;
  color: #fff;
}
.KomentarModal_successBtn__39HIZ:hover {
  background-color: #9b7725;
}
.KomentarModal_cancelBtn__lHTWw {
  background-color: #ebebeb;
  color: #808080;
}
.KomentarModal_cancelBtn__lHTWw:hover {
  background-color: #a09f9f;
  color: #fff;
}
.KomentarModal_textarea__P9EMr:focus,
.KomentarModal_modalInput__BxiZa:focus {
  border: 1px solid #cb9c2d !important;
  outline: none !important;
}
.KomentarModal_textarea__P9EMr:hover,
.KomentarModal_modalInput__BxiZa:hover {
  border: 1px solid #cb9c2d;
}
`, "",{"version":3,"sources":["webpack://./src/scenes/evidencija/components/Supervizije/Accordions/KomentarModal/KomentarModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;EACV,0BAA0B;AAC5B;AACA;;;;EAIE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qCAAqC;EACrC,yBAAyB;AAC3B;AACA;;EAEE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,gBAAgB;AAClB;AACA;;EAEE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;AACzB;AACA;;;EAGE,WAAW;AACb;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;AACA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,sCAAsC;EACtC,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,wCAAwC;EACxC,cAAc;EACd,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;;EAEE,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;AACA;;;;EAIE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;;EAEE,oCAAoC;EACpC,wBAAwB;AAC1B;AACA;;EAEE,yBAAyB;AAC3B","sourcesContent":[".modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #000000d6;\n  z-index: 100;\n  justify-content: center;\n}\n.exitBtn {\n  position: absolute;\n  top: 5%;\n  right: 3%;\n  cursor: pointer;\n}\n.infoModal {\n  flex-direction: column;\n  justify-content: center;\n  width: 85%;\n  padding: 24px 0px 24px 0px;\n}\n.infoModal,\n.modalWrapper,\n.btnRow,\n.modalOverlay {\n  display: flex;\n  align-items: center;\n}\n.btnRow {\n  justify-content: flex-end;\n  gap: 24px;\n  width: 90%;\n  margin-top: 36px;\n  margin-bottom: 32px;\n}\n.modalWrapper {\n  justify-content: flex-start;\n  flex-direction: column;\n  width: 70%;\n  max-height: 95vh;\n  border-radius: 16px;\n  border: 1px solid #d1d9e2;\n  box-shadow: 0px 1px 2px 0px #1018280d;\n  background-color: #ffffff;\n}\n.title,\n.subtitle {\n  font-family: Inter;\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 34px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #4d4d4d;\n}\n.subtitle {\n  margin-top: -16px;\n}\n.inputWrapper {\n  gap: 16px;\n  margin-top: 24px;\n}\n.inputWrapper,\n.inputColumn {\n  display: flex;\n  flex-direction: column;\n  align-items: baseline;\n  justify-content: center;\n}\n.modalInput,\n.inputColumn,\n.inputWrapper {\n  width: 100%;\n}\n.modalInput {\n  height: 32px;\n  text-align: left;\n  color: #5f6d7e;\n  font-family: Inter;\n  font-size: 16px;\n  letter-spacing: -0.001em;\n}\n.modalInput,\n.textarea {\n  padding: 8px;\n  font-weight: 500;\n  box-shadow: 4px 4px 64px 0px #5f6d7e1a;\n  border: 1px solid #d8dbdf;\n  border-radius: 8px;\n}\n.textarea {\n  width: 102%;\n  height: 130px;\n  background: #ffffff;\n  background-origin: border-box;\n  background-clip: content-box, border-box;\n  color: #828d9a;\n  resize: none;\n  box-sizing: border-box;\n}\n.label {\n  text-align: left;\n  color: #5f6d7e;\n}\n.cancelBtn,\n.successBtn {\n  width: 27%;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  height: 52px;\n}\n.cancelBtn,\n.successBtn,\n.label,\n.textarea {\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.016px;\n}\n.successBtn {\n  background: #cb9c2d;\n  color: #fff;\n}\n.successBtn:hover {\n  background-color: #9b7725;\n}\n.cancelBtn {\n  background-color: #ebebeb;\n  color: #808080;\n}\n.cancelBtn:hover {\n  background-color: #a09f9f;\n  color: #fff;\n}\n.textarea:focus,\n.modalInput:focus {\n  border: 1px solid #cb9c2d !important;\n  outline: none !important;\n}\n.textarea:hover,\n.modalInput:hover {\n  border: 1px solid #cb9c2d;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `KomentarModal_modalOverlay__DfBhc`,
	"exitBtn": `KomentarModal_exitBtn__EgV1Q`,
	"infoModal": `KomentarModal_infoModal__lCz7l`,
	"modalWrapper": `KomentarModal_modalWrapper__gQez2`,
	"btnRow": `KomentarModal_btnRow__aHLF2`,
	"title": `KomentarModal_title__iXS7x`,
	"subtitle": `KomentarModal_subtitle__FpAPT`,
	"inputWrapper": `KomentarModal_inputWrapper__sP5sn`,
	"inputColumn": `KomentarModal_inputColumn__4Ja9e`,
	"modalInput": `KomentarModal_modalInput__BxiZa`,
	"textarea": `KomentarModal_textarea__P9EMr`,
	"label": `KomentarModal_label__OZ2+A`,
	"cancelBtn": `KomentarModal_cancelBtn__lHTWw`,
	"successBtn": `KomentarModal_successBtn__39HIZ`
};
export default ___CSS_LOADER_EXPORT___;
